export const PLANS = {
  free: {
    name: "Free",
    price: 0,
    limits: {
      collaborators: 3,
      custom_domain: false,
      watermark: false,
      cms_posts: 50,
      storage: 2 * 1024 * 1024 * 1024,
      file_upload_size: 25 * 1024 * 1024,
    },
  },
};
